import _ from 'lodash';
import request from 'superagent';
import { receiveError as receivePacerError } from './pacerSearch';
import * as types from '../actionTypes/relatedTransactionActionTypes';

function mapResponseErrorsToMessage(err) {
  const request_id = _.get(err, ['response', 'body', 'error', 'request_id']);
  const errorMessageExtra = request_id
    ? `When contacting support, please quote Request ID '${request_id}'`
    : '';

  return {
    // We want to hide real messages from user since traces are confusing to them
    // TODO: coordinate with API to surface proper errors such as field validation?
    messages: [
      'PACER is experiencing some issues. Please try again in a few minutes.',
      errorMessageExtra,
    ],
    // but we include the real message in the details so we receive it in the sentry report
    details: _.get(err, ['response', 'body', 'error']) || [],
  };
}

function receiveError(err, msg) {
  return {
    type: types.SERVICE_ERROR,
    error: msg,
    errors: msg,
  };
}

function onFailure(dispatch) {
  return function (err) {
    return dispatch(receiveError(types.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
  };
}
function requestCaseData(params, dispatch) {
  dispatch({
    type: types.REQUEST_RELATED_TRANSACTION_DATA,
    params,
  });

  dispatch({
    type: types.RESET_SERVICE_ERROR,
  });
}

function mapRelatedTransactionParserToData(response) {
  const transactions = response.body;
  transactions.entries = transactions.json_data || [];
  delete transactions.json_data;
  return Object.keys(transactions).map(key => [key, transactions[key]]);
}

function receiveRelatedTransactionParser(response, filters) {
  const data = mapRelatedTransactionParserToData(response, filters);

  return {
    type: types.RECEIVE__RELATED_TRANSACTION_DATA,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []),
    lastUpdated: _.get(response.body, `queries[0].${filters.type}[0].meta.timestamp`),
    receipt: null,
  };
}
export const getParserSearchData = params => (dispatch) => {
  requestCaseData(params, dispatch);
  return request
    .post(`/parser/direct/related_transactions_search/${params.case_uuid}/${params.keyword}/${params.date_from}/${params.date_to}/${params.doc_from}/${params.doc_to}/${params.sort_field}/${params.sort_direction}?page=${params.page_num}`)
    .set('Accept', 'application/json')
    .then(
      response => dispatch(receiveRelatedTransactionParser(response, params)),
      onFailure(dispatch),
    );
};
function mapResponseToData(response) {
  const related_transaction = response.body.items;
  related_transaction.entries = related_transaction.related_transactions || [];
  related_transaction.total_items = related_transaction.related_transactions.length;

  delete related_transaction.related_transactions;
  delete related_transaction.receipts;
  delete related_transaction.headers;

  return Object.keys(related_transaction).map(key => [key, related_transaction[key]]);
}

function receiveTransactionsPurchased(response, filters) {
  const data = mapResponseToData(response);

  return {
    type: types.RECEIVE__RELATED_TRANSACTION_DATA,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []), // old
    lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
    receipt: _.get(response.body, 'items.receipts[0].text'),
  };
}
export const getCaseData = params => (dispatch) => {
  requestCaseData(params, dispatch);

  return request
    .get('/ir-search/query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        // window.refresh_menu(params.case_uuid);

        if (!_.isEmpty(response.body.error)) {
          return onFailure(dispatch)({ response });
        }

        return dispatch(receiveTransactionsPurchased(response, params));
      },
      onFailure(dispatch),
    );
};

export const purchaseRelatedTransactionsCaseData = params => (dispatch) => {
  requestCaseData(params, dispatch);

  return request
    .get('/ir-search/pacer-query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
      keyword: params.keyword,
      date_from: params.date_from,
      date_to: params.date_to,
      doc_from: params.doc_from,
      doc_to: params.doc_to,
      doc_type: params.doc_type,
      show_pending: params.show_pending,
      show_terminated: params.show_terminated,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        window.refresh_menu(params.case_uuid);

        if (!_.isEmpty(response.body.error)) {
          return onFailure(dispatch)({ response });
        }

        return dispatch(receiveTransactionsPurchased(response, params));
      },
      onFailure(dispatch),
    );
};




// WEBPACK FOOTER //
// ./src/redux/actions/relatedTransactionActions.js